<div class="modal-header">
  <h4 class="modal-title">{{ validatedTool.tool.name.displayName }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <div ngbAccordion>
    <div ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Parameters</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ch-tool-parameters
              [validatedTool]="validatedTool"
              (parametersChanged)="onParametersChanged()"></ch-tool-parameters>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Input Files</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ch-tool-inputs
              [validatedTool]="validatedTool"
              [sessionData]="sessionData"
              (updateBindings)="setBindings($event)"></ch-tool-inputs>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Run Options</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ch-run-options [validatedTool]="validatedTool"></ch-run-options>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Computing Resources</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ch-tool-resources
              [validatedTool]="validatedTool"
              [origTool]="origTool"
              (resourcesChanged)="onResourcesChanged()"></ch-tool-resources>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-secondary" (click)="activeModal.close()">Close</button>
</div>
